import {DetailTable} from '../../mapping-classes/detail-table';

export class Claims implements DetailTable {
  restrictedData: boolean;
  title: string;
  rowHeaders: string[];
  rowData: any[];
  totalOutstandingAmount;
  totalOriginalAmount;
  shieldedText = 'Afgeschermd';
  errorText: string;

  constructor(response: any) {
    if (response.ListOfInfo || response.listOfError) {
      this.createErrorMessage(response);
    } else {
      this.restrictedData = response.detailsViewObject['restrictedData'];
      this.totalOutstandingAmount = response.detailsViewObject['totalOutstandingAmount'];
      this.totalOriginalAmount = response.detailsViewObject['totalOriginalAmount'];
      this.rowHeaders = [];
      this.rowData = [];
      this.setRowHeaders();
      this.setRowData(response);
    }
  }

  createErrorMessage(response) {
    if (response.ListOfInfo && response.ListOfInfo.length !== 0) {
      if (response.ListOfInfo[0].code === 'CIV_F025') {
        this.errorText = 'Er zijn geen (openstaande) vorderingen in de afgelopen 120 dagen.';
      } else if (response.ListOfInfo[0].code) {
        this.errorText = 'Er ging iets fout bij het ophalen van de vorderingsgegevens.';
      }
    } else if (response.listOfError && response.listOfError.length !== 0) {
      if (response.listOfError[0].code === 'CIV_F025') {
        this.errorText = 'Er zijn geen (openstaande) vorderingen in de afgelopen 120 dagen.';
      } else if (response.listOfError[0].code) {
        this.errorText = 'Er ging iets fout bij het ophalen van de vorderingsgegevens.';
      }
    }
  }

  setRowHeaders() {
    this.rowHeaders = ['claimId',
      'premiumPeriod',
      'directDebitType',
      'reminderPhaseDescription',
      'lastReminderDate',
      'desiredClaimDate',
      'originalAmount',
      'outstandingAmount'];
  }

  setRowData(response) {
    response.detailsViewObject.claims.forEach((claim) => {
      if (claim['premiumPeriodStartDate'] !== undefined && claim['premiumPeriodEndDate'] !== undefined) {
        claim.premiumPeriod = claim['premiumPeriodStartDate'] + '/' + claim['premiumPeriodEndDate'];
      }
      if (this.restrictedData) {
        claim.originalAmount = this.shieldedText;
        claim.outstandingAmount = this.shieldedText;
        claim.financialFacts.forEach((financialFact) => {
          financialFact.mutationAmount = this.shieldedText;
          financialFact.claimAmount = this.shieldedText;
          financialFact.outstandingClaimAmount = this.shieldedText;
        });
      }
      this.rowData.push(claim);
    });
  }

}
